import { render, staticRenderFns } from "./Fund.vue?vue&type=template&id=b0a75e86&scoped=true&lang=pug&"
import script from "./Fund.vue?vue&type=script&lang=js&"
export * from "./Fund.vue?vue&type=script&lang=js&"
import style0 from "./Index.scss?vue&type=style&index=0&id=b0a75e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a75e86",
  null
  
)

export default component.exports